module.exports = __webpack_public_path__ + "static/media/premium-high-photo-product.aa48baa3.jpg";